import {Observable} from 'rxjs/Observable';
import {DataSource} from '@angular/cdk/collections';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {ApiService} from '../../services/api.service';
import {BaseObject} from '../Entities/BaseObject';
import {SortInfo} from '../Helpers/SortInfo';
import {Filter} from '../Helpers/Filter';
import {Pagination} from '../Helpers/Pagination';

/**
 * Data source to provide what data should be rendered in the table. The observable provided
 * in connect should emit exactly the data that should be rendered by the table. If the data is
 * altered, the observable should emit that new set of data on the stream. In our case here,
 * we return a stream that contains only one set of data that doesn't change.
 */
export abstract class BaseDataSource<T extends BaseObject> extends DataSource<any> {
    _data: BehaviorSubject<T[]> = new BehaviorSubject<T[]>([]);

    dataSize: Number = 0;
    summary = {};

    constructor(private dataService: ApiService<T>) {
        super();
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<T[]> {
        return this._data;
    }

    disconnect() {
    }

    loadPage(pagination: Pagination, sort: SortInfo = null, filters: Filter[], params: Object = {}) {
        return this.dataService.getPaginatedList(pagination, sort, filters, params).subscribe(data => {
            this.dataSize = data.pagination.total;
            this.summary = data.summary;
            this._data.next(data.results);
        });
    }

    getData(): T[] {
        return this._data.getValue();
    }

    getSummary(): any {
        return this.summary;
    }
}


// WEBPACK FOOTER //
// /app/src/model/DataSources/BaseDataSource.ts